import React from 'react';
import "../theme/app-styles.css";

const Footer: React.FC = () => {
  return (
    <footer className='footer'>
    <p>&copy; 2024 Nampa-OCIA</p>
    <p>email: nampaocia@gmail.com</p>
    <p>phone: (208) 615-9318</p>
  
  </footer>
  );
};

export default Footer;
